import { IBondGelemExtremeReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_YIELD_EXTREME';

export type IReportYieldExtremeItem = IBondGelemExtremeReport & { __isSelected: boolean };
